import MobileCard, { DSMobileCardWithSchema } from './Card.js';
import MobileGroup, { DSMobileCardGroupWithSchema } from './Group.js';
// import { ActionAddon } from './ActionAddon.js';

MobileCard.Group = MobileGroup;
const DSMobileCard = MobileCard;

// export { ActionAddon };
export { SubIcons } from './CardIcons.js';
export { DSMobileCard, DSMobileCardWithSchema, DSMobileCardGroupWithSchema };
